import React from 'react'
import { BaseCard } from './BaseCard'
import { APIClient } from '@/services'
import { Organisation } from '@/features'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'

export const OrganizationCard = ({ item }: RenderItemProps) => {

  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <Organisation.OrganisationSelect
        loadInitialValue
        {...prompt.form.register('organization')}
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
      />
    </BaseCard>
  )
}
